export class ParkTurbineNavigation {

  private parks: any;
  private turbines: any;

  static mapParkTurbineNavigation(data: any, menuType: string) {
    if (data) {
      switch (menuType) {
        case 'grouped':
          return new ParkTurbineNavigation({
            parks: data,
            turbines: this.generateTurbinesList(data)
          });
        default:
          return new ParkTurbineNavigation({
            parks: this.generateParkList(data),
            turbines: this.generateTurbinesList(data)
          });
      }
    } else {
      return null;
    }
  }

  static mapMenusDropDown(data: any, menuType: string) {
    if (data) {
      switch (menuType) {
        case 'grouped':
          return new ParkTurbineNavigation({
            portfolios: data,
            parks: this.generateParkListGrouped(data),
            turbines: this.generateTurbinesList(data)
          });
        default:
          return new ParkTurbineNavigation({
            portfolios: data,
            parks: this.generateParkList(data),
            turbines: this.generateTurbinesList(data)
          });
      }
    } else {
      return null;
    }
  }

  static generateParkListGrouped(data) {
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    data.forEach(el => {
      el.countries = [];
      el.parks.forEach(park => {
       if(!el.countries.find(elem => (elem.name === park.country.name))){
         let country = {
           name: park.country.name,
           parks: []
         }
         country.parks.push(park);
         el.countries.push(country);
       }else {
        el.countries.find(elem => (elem.name === park.country.name)).parks.push(park);
       }
      })
      el.countries.forEach(el => {
        el.parks.sort((a, b) => collator.compare(a.name, b.name));
      })
    })
    return data
  }
  
  static generateParkList(data: any) {
    return this.sort(data.flatMap((countries: any) => countries.parks), 'name');
  }

  static generateTurbinesList(data: any) {
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    data.flatMap((countries: any) => countries.parks).forEach((park: any) => {
      this.sort(park.turbines, 'codeDisplay');
    });
    data.forEach(el => {
      el.parks.sort((a, b) => collator.compare(a.name, b.name));
    })
    return this.sort(data.flatMap((d: any) => d.parks), 'name');
  }

  static sort(array: [], property: string): [] {
    return array.sort((a: any, b: any) => a[property].localeCompare(b[property], undefined, { numeric: true, sensitivity: 'base' }));
  }

  constructor(init: Partial<ParkTurbineNavigation>) {
    Object.assign(this, init);
  }

}
